import { useEffect, useState } from 'react';
import Breakjs from 'breakjs';

import { BREAKPOINTS } from 'newJs/config';

const layout = Breakjs(BREAKPOINTS);

const useBreakpoints = () => {
    // In some rare cases layout.current() === undefined and it breaks functionality
    // More info: https://jira.dev.inbox.lv/browse/MAIL-4655
    const [breakpoint, setBreakpoint] = useState(layout.current() || 'md');

    useEffect(() => {
        let isMounted = true;
        const currentBreakpoint = layout.current();
        if (currentBreakpoint) setBreakpoint(currentBreakpoint);

        const onLayoutChange = (bp) => {
            // console.log('bp changed:', bp);
            if (isMounted) setBreakpoint(bp);
        };

        layout.addChangeListener(onLayoutChange);

        return () => {
            isMounted = false;
            layout.removeChangeListener(onLayoutChange);
        };
    }, []);

    return { list: BREAKPOINTS, name: breakpoint };
};

export default useBreakpoints;
